<template>
  <div
    v-if="visible"
    class="nup-choice-success"
    @click.self="$emit('close')"
  >
    <div class="nup-choice-success__wrap">
      <div class="nup-choice-success__stage">
        <img
          class="nup-choice-success__panel"
          :src="panelSrc"
          :alt="copy.choiceSuccessAlt"
          width="750"
          height="781"
        >
        <div class="nup-choice-success__cta">
          <PrimaryButton
            :text="copy.deposit"
            variant="solid"
            @click="$emit('deposit')"
          />
        </div>
        <button
          type="button"
          class="nup-choice-success__close"
          @click="$emit('close')"
        >
          <img
            :src="closeIcon"
            :alt="copy.close"
            width="48"
            height="48"
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { DEFAULT_CHOICE_KEY, type ChoiceKey } from '@ark/nup-shared';
import { getCopy } from '../constants/copy';
import { findChoiceSuccessImage } from '../constants/rewards';
import { useNupLang } from '../composables/use-nup-lang';
import closeIcon from '../assets/dialog-close.svg';
import PrimaryButton from './primary-button.vue';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  choiceKey: {
    type: String,
    default: DEFAULT_CHOICE_KEY
  },
  group: {
    type: String,
    default: 'entry'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  const panelSrc = computed(() => {
    const key = props.choiceKey as ChoiceKey;
    return findChoiceSuccessImage(key, isEn.value, props.group === 'advanced');
  });
  return {
    closeIcon,
    copy,
    panelSrc
  };
};
__sfc_main.components = Object.assign({
  PrimaryButton
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.nup-choice-success {
  position: fixed;
  inset: 0;
  z-index: 42;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
}

.nup-choice-success__wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 750px;
}

.nup-choice-success__stage {
  position: relative;
  width: 750px;
}

.nup-choice-success__panel {
  display: block;
  width: 750px;
  height: 781px;
  pointer-events: none;
}

.nup-choice-success__cta {
  position: absolute;
  left: 50%;
  top: 540px;
  width: 400px;
  transform: translateX(-50%);
}

.nup-choice-success__cta :deep(.nup-btn--solid) {
  width: 400px;
  height: 88px;
}

.nup-choice-success__close {
  position: absolute;
  left: 50%;
  top: 670px;
  z-index: 2;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  background: transparent;
  transform: translateX(-50%);
  cursor: pointer;
}

.nup-choice-success__close img {
  display: block;
  width: 48px;
  height: 48px;
}
</style>
